function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.163 9.417h2.924v10.19H5.163V9.417zm1.402-1.082h-.02C5.485 8.335 4.8 7.556 4.8 6.57c0-1.006.706-1.77 1.786-1.77 1.078 0 1.742.762 1.763 1.767 0 .987-.685 1.768-1.784 1.768zm13.031 11.276h-3.315v-5.273c0-1.38-.518-2.322-1.659-2.322-.872 0-1.357.635-1.583 1.249-.085.219-.071.525-.071.833v5.513H9.683s.043-9.34 0-10.19h3.285v1.6c.194-.7 1.243-1.698 2.918-1.698 2.078 0 3.71 1.467 3.71 4.622v5.666z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/linked-in.1c61ef5c.svg";
export { SvgComponent as ReactComponent };